var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShutdownsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V11.25",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9985 23.25C17.7915 23.25 17.6235 23.418 17.625 23.625C17.625 23.832 17.793 24 18 24C18.207 24 18.375 23.832 18.375 23.625C18.375 23.418 18.207 23.25 17.9985 23.25",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 21.5717V14.4287C4.5 12.0257 5.778 9.80423 7.854 8.59523L14.604 4.66673C16.7025 3.44573 19.296 3.44573 21.3945 4.66673L28.1445 8.59523C30.222 9.80423 31.5 12.0257 31.5 14.4287V21.5717C31.5 23.9747 30.222 26.1962 28.146 27.4052L21.396 31.3337C19.2975 32.5547 16.704 32.5547 14.6055 31.3337L7.8555 27.4052C5.778 26.1962 4.5 23.9747 4.5 21.5717Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShutdownsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ShutdownsIcon.3481e9cb.svg";
export { ForwardRef as ReactComponent };